import { Injectable } from '@angular/core';

import { DataManager } from "techlify-ng";

/**
 * Service that provides Color Data
 * 
 * @author Joshua Kissoon
 * @since 20180314
 */
@Injectable()
export class UserDataService {
    private data: any;

    constructor(private dataManager: DataManager) { }

    getUsers(): any {
        var promise;
        if (undefined !== this.data) {
            promise = new Promise((resolve, reject) => {
                resolve(this.data);
            });

            return promise;
        }

        promise = this.dataManager.GET("api/users", { sort_by: "name|ASC" });

        promise.then(
            res => {
                this.data = res;
            }
        );

        return promise;
    }
}